import React, { useState, useEffect } from 'react';
import { Row, Col, Modal, FormGroup } from 'react-bootstrap';
import { get, isEmpty, cloneDeep, set } from 'lodash';
import { useSelector, useDispatch } from 'react-redux';
import Select from 'react-select';
import { useTranslation } from 'react-i18next';
import * as action from '../../store/PlanningBottom.action';
import { convertSelectLabel, createOptions, customStyles, RightsAccess } from '../../../../Components/helper';
import * as customAction from '../../../RangePlan/CustomSections/store/CustomSections.action';
import ConfirmationPopup from '../../../../Components/ModalPopup/ConfirmationPopup';
import Loader from '../../../../Components/Utility/Loader/Loader';

function ChannelInfoModal() {
  const reducer = useSelector((estate) => estate);
  const { t } = useTranslation('common');
  const dispatch = useDispatch();
  const { PlanningBottomReducer, customSectionData } = reducer;
  const { channelInfoModalState, updateChannelInfoData, ChannelListData } = PlanningBottomReducer;
  const { rangePlanRight } = RightsAccess();
  const [state, setState] = useState({
    columns: [
      {
        channelName: '',
        channelType: '',
        unit: {},
        cost: {},
        isActive: true,
        isDeleted: false,
        position: ChannelListData?.length + 1 || 1,
        refKey: '',
      },
    ],
    error: [],
    loading: false,
    locationArray: [],
    showChangeModal: false,
    changedIndex: null,
    typeValue: '',
    copyUpdateValue: {},
    isChanged: false,
  });
  const [subLocationData, setSubLocationData] = useState([]);
  const { locationArray, columns, showChangeModal, changedIndex, typeValue, loading, copyUpdateValue, isChanged } = state;
  const { currSectionList } = customSectionData;

  const additionColumnOption = [
    {
      label: 'Buy Dependent',
      value: 'buyDependent',
    },
    {
      label: 'Independent',
      value: 'independent',
    },
  ];
  const unitsColumnOption = [
    {
      label: 'Source',
      value: 'source',
    },
    {
      label: 'Manual',
      value: 'manual',
    },
  ];

  useEffect(() => {
    const init = async () => {
      setState((prevState) => ({ ...prevState, loading: true }));
      await dispatch(customAction.fetchAllSections());
      setState((prevState) => ({ ...prevState, loading: false }));
    };
    if (rangePlanRight) {
      init();
    }
    return () => {
      dispatch(action.editChannelInfo(null));
    };
  }, [dispatch]);

  useEffect(() => {
    if (currSectionList && currSectionList.length > 0) {
      const filteredLocation = [];
      currSectionList?.forEach((sect) => {
        const numColumns = sublocationFun(sect?.columns);
        if (numColumns?.length > 0) {
          sect.columns = numColumns;
          filteredLocation.push(sect);
        }
      });
      const loc = createOptions(filteredLocation, 'name');
      setState((prev) => ({
        ...prev,
        locationArray: loc,
      }));
    }
  }, [currSectionList]);

  useEffect(() => {
    if (!isEmpty(updateChannelInfoData)) {
      const data = [updateChannelInfoData];
      setState((prev) => ({
        ...prev,
        columns: data,
        copyUpdateValue: updateChannelInfoData?.channelType,
      }));
    }
  }, [updateChannelInfoData]);

  const sublocationFun = (data) => {
    return data.filter((val) => {
      let flag = false;
      if (val?.columnType === 'manual' && val?.type === 'Number') {
        flag = true;
      }
      return flag;
    });
  };

  const changeChannelType = async (copyState, index, key, value) => {
    if (updateChannelInfoData && value !== copyUpdateValue) {
      setState((prestate) => ({
        ...prestate,
        showChangeModal: true,
        changedIndex: index,
        typeValue: value,
        isChanged: true,
      }));
    } else if (updateChannelInfoData && value === copyUpdateValue) {
      copyState[index][key] = value;
      setState((prestate) => ({
        ...prestate,
        isChanged: false,
      }));
    } else {
      copyState[index][key] = value;
    }
    return copyState;
  };

  const handleChange = async (value, index, key, objVal) => {
    let copyState = cloneDeep(columns);
    if (key === 'location') {
      const subLoc = [];
      value?.columns?.forEach((sub) => {
        const obj = {
          name: sub.title,
          label: sub.title,
          _id: sub._id,
          sectionId: sub.sectionId,
        };
        subLoc.push(obj);
      });
      setSubLocationData(subLoc);
    }
    if (key === 'channelName') {
      copyState[index][key] = value;
      if (!updateChannelInfoData) {
        copyState[index].refKey = value.split(' ').join('').toLowerCase();
      }
    }
    if (key === 'unit' || key === 'cost') {
      copyState[index][key].type = value;
      if (value === 'manual') {
        delete copyState[index][key].location;
        delete copyState[index][key].subLocation;
        copyState[index][key].type = value;
        copyState[index][key].value = 'number';
      } else {
        copyState[index][key].type = value;
        delete copyState[index][key].value;
      }
    } else if (objVal === 'unit' || objVal === 'cost') {
      copyState[index][objVal][key] = value._id;
    } else if (key === 'channelType') {
      copyState = await changeChannelType(copyState, index, key, value);
    } else {
      copyState[index][key] = value;
    }
    setState((prevState) => ({ ...prevState, columns: copyState }));
  };

  const checkValidation = () => {
    const copyColumn = cloneDeep(columns);
    let hasError = false;
    const errors = [];
    copyColumn.forEach((column, index) => {
      if (isEmpty(get(column, 'channelName', '').trim())) {
        hasError = true;
        set(errors, `[${index}].channelName`, <span className="error-message">{t('PLANING_BOTTOM_UP.CHANNEL.MODAL.CHANNEL_NAME_REQUIRED')}</span>);
      }
      if (isEmpty(get(column, 'channelType'))) {
        hasError = true;
        set(errors, `[${index}].channelType`, <span className="error-message">{t('PLANING_BOTTOM_UP.CHANNEL.MODAL.CHANNEL_TYPE_REQUIRED')}</span>);
      }

      if (isEmpty(column.unit)) {
        hasError = true;

        set(errors, `[${index}].unitType`, <span className="error-message">{t('PLANING_BOTTOM_UP.CHANNEL.MODAL.UNIT_REQUIRED')}</span>);
      } else if (column.unit.type === 'source') {
        if (isEmpty(get(column, 'unit.location'))) {
          hasError = true;
          set(errors, `[${index}].unitLocation`, <span className="error-message">{t('PLANING_BOTTOM_UP.CHANNEL.MODAL.LOCATION_REQUIRED')}</span>);
        }
        if (isEmpty(get(column, 'unit.subLocation'))) {
          hasError = true;
          set(errors, `[${index}].unitSubLocation`, <span className="error-message">{t('PLANING_BOTTOM_UP.CHANNEL.MODAL.SUB_LOCATION_REQUIRED')}</span>);
        }
      }
      if (isEmpty(column.cost)) {
        hasError = true;

        set(errors, `[${index}].costType`, <span className="error-message">{t('PLANING_BOTTOM_UP.CHANNEL.MODAL.COST_REQUIRED')}</span>);
      } else if (column.cost.type === 'source') {
        if (isEmpty(get(column, 'cost.location'))) {
          hasError = true;
          set(errors, `[${index}].costLocation`, <span className="error-message">{t('PLANING_BOTTOM_UP.CHANNEL.MODAL.LOCATION_REQUIRED')}</span>);
        }
        if (isEmpty(get(column, 'cost.subLocation'))) {
          hasError = true;
          set(errors, `[${index}].costSubLocation`, <span className="error-message">{t('PLANING_BOTTOM_UP.CHANNEL.MODAL.SUB_LOCATION_REQUIRED')}</span>);
        }
      }
    });

    setState((prevState) => ({ ...prevState, error: errors }));
    return hasError;
  };

  const addColumnName = (e, index) => {
    e.preventDefault();
    if (!checkValidation()) {
      const initLen = ChannelListData?.length + 1;
      const copyState = cloneDeep(columns);
      set(copyState, `[${index + 1}].channelName`, '');
      set(copyState, `[${index + 1}].channelType`, '');
      set(copyState, `[${index + 1}].unit`, {});
      set(copyState, `[${index + 1}].cost`, {});
      set(copyState, `[${index + 1}].isActive`, true);
      set(copyState, `[${index + 1}].isDeleted`, false);
      set(copyState, `[${index + 1}].position`, initLen + index + 1);
      set(copyState, `[${index + 1}].refKey`, '');

      setState((prevState) => ({ ...prevState, columns: copyState }));
    }
  };

  const removeColumnName = (e, index) => {
    e.preventDefault();
    const copyState = cloneDeep(state.columns);
    copyState.splice(index, 1);
    setState((prevState) => ({ ...prevState, columns: copyState }));
  };

  const addChannel = async () => {
    if (!checkValidation()) {
      setState((prevState) => ({ ...prevState, loading: true }));
      const res = await dispatch(action.addChannel(columns, t));
      if (res === 'err') {
        setState((prevState) => ({ ...prevState, loading: false }));
      } else if (res) {
        await dispatch(action.loaderAction(true));
        await dispatch(action.getChannelList());
        await dispatch(action.loaderAction(false));
        await dispatch(action.controlChannelModal(false));
        setState((prevState) => ({ ...prevState, loading: false }));
      }
    }
  };

  const editChannelList = async () => {
    if (!checkValidation()) {
      const data = columns[0];
      const obj = {
        id: data._id,
        channelName: data.channelName,
        channelType: data.channelType,
        unit: data.unit,
        cost: data.cost,
        isActive: true,
        isDeleted: false,
        position: data.position,
        previousKey: isChanged && copyUpdateValue,
        refKey: data.refKey,
      };
      setState((prevState) => ({ ...prevState, loading: true }));
      const res = await dispatch(action.editChannel(obj, t));
      if (res === 'err') {
        setState((prevState) => ({ ...prevState, loading: false }));
      } else if (res) {
        await dispatch(action.loaderAction(true));
        await dispatch(action.getChannelList());
        await dispatch(action.loaderAction(false));
        await dispatch(action.editChannelInfo(null));
        setState((prevState) => ({ ...prevState, loading: false }));
      }
    }
  };

  const changeType = () => {
    const copyState = cloneDeep(columns);
    copyState[changedIndex].channelType = typeValue;
    setState((prevState) => ({
      ...prevState,
      columns: copyState,
      showChangeModal: false,
      changedIndex: null,
      typeValue: '',
    }));
  };

  const getSubLocationValue = (loc, sub) => {
    const locFind = locationArray?.find((locId) => locId._id === loc);
    const subFind = locFind?.columns?.find((locId) => locId._id === sub);
    if (subFind) {
      subFind.name = subFind.title;
      subFind.label = subFind.title;
      subFind.value = subFind._id;
      return subFind;
    }
    return null;
  };

  const showAddDeleteButtons = (index) => {
    return columns?.length - 1 === index ? (
      <>
        <button className="btn btn-outline m-0" onClick={(e) => addColumnName(e, index)}>
          <span className="icon-add" />
        </button>
        {columns?.length > 1 && (
          <button className="btn btn-outline m-0" onClick={(e) => removeColumnName(e, index)}>
            <span className="icon-delete" />
          </button>
        )}
      </>
    ) : (
      <div className="web-filter">
        <button className="btn btn-outline m-0" onClick={(e) => removeColumnName(e, index)}>
          <span className="icon-delete" />
        </button>
      </div>
    );
  };
  return (
    <>
      <Modal
        className="custom-modal modal-medium-2x supplier-overview-modal"
        size="md"
        show={channelInfoModalState}
        onHide={() => dispatch(action.controlChannelModal(false))}
        backdrop="static"
      >
        <Modal.Header>
          <Modal.Title>
            {updateChannelInfoData ? t('PLANING_BOTTOM_UP.CHANNEL.MODAL.UPDATE_CHANNEL_TITLE') : t('PLANING_BOTTOM_UP.CHANNEL.MODAL.ADD_NEW_CHANNEL_TITLE')}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {!loading ? (
            <>
              <Row>
                <Col lg="12">
                  {Array.isArray(columns) &&
                    columns.length > 0 &&
                    columns.map((item, index) => {
                      return (
                        <div className="d-flex mb-3" key={index}>
                          <div className="card card-body  p-3 mr-2 rounded-0 theme-border">
                            <FormGroup>
                              <div className="input-group form-floating-label fixed-label">
                                <input
                                  type="text"
                                  name="costingTempName"
                                  placeholder={
                                    updateChannelInfoData
                                      ? t('PLANING_BOTTOM_UP.CHANNEL.MODAL.UPDATE_CHANNEL_TITLE')
                                      : t('PLANING_BOTTOM_UP.CHANNEL.MODAL.ADD_CHANNEL_TITLE')
                                  }
                                  className="form-control"
                                  maxLength="30"
                                  value={item?.channelName}
                                  onChange={(e) => handleChange(e.target.value, index, 'channelName')}
                                />
                                <label className="asterisk-req">{t('PLANING_BOTTOM_UP.CHANNEL.MODAL.CHANNEL_NAME')}</label>
                                <div className="text-count">{item?.channelName?.length}/30</div>
                              </div>
                              <div>{get(state.error, `${index}.channelName`)}</div>
                            </FormGroup>
                            <FormGroup className="mt-2 custom-react-select">
                              <label className="field-lbl asterisk-req">{t('PLANING_BOTTOM_UP.CHANNEL.MODAL.CHANNEL_TYPE')}</label>
                              <Select
                                menuPlacement="bottom"
                                options={additionColumnOption}
                                name="type"
                                value={item?.channelType === 'buyDependent' ? convertSelectLabel('Buy Dependent', true) : convertSelectLabel(item?.channelType)}
                                styles={customStyles}
                                onChange={(selected) => handleChange(selected.value, index, 'channelType')}
                              />

                              <div>{get(state.error, `${index}.channelType`)}</div>
                            </FormGroup>
                            <FormGroup className="mt-2 custom-react-select">
                              <label className="field-lbl asterisk-req">{t('PLANING_BOTTOM_UP.CHANNEL.MODAL.UNITS')}</label>
                              <Select
                                menuPlacement="bottom"
                                options={unitsColumnOption}
                                name="supplier"
                                value={convertSelectLabel(item?.unit?.type)}
                                styles={customStyles}
                                onChange={(selected) => handleChange(selected.value, index, 'unit')}
                              />

                              <div>{get(state.error, `${index}.unitType`)}</div>
                            </FormGroup>

                            {item?.unit?.type === 'source' && (
                              <FormGroup className="mt-2 custom-react-select">
                                <label className="field-lbl asterisk-req">{t('PLANING_BOTTOM_UP.CHANNEL.MODAL.LOCATION')}</label>
                                <Select
                                  menuPlacement="bottom"
                                  options={locationArray}
                                  name="supplier"
                                  value={locationArray.find((val) => val._id === item?.unit?.location)}
                                  styles={customStyles}
                                  onChange={(selected) => handleChange(selected.value, index, 'location', 'unit')}
                                />
                                <div>{get(state.error, `${index}.unitLocation`)}</div>
                              </FormGroup>
                            )}
                            {item?.unit?.location && (
                              <FormGroup className="mt-2 custom-react-select">
                                <label className="field-lbl asterisk-req">{t('PLANING_BOTTOM_UP.CHANNEL.MODAL.SUB_LOCATION')}</label>
                                <Select
                                  menuPlacement="bottom"
                                  options={subLocationData}
                                  name="subLocation"
                                  value={getSubLocationValue(item?.unit?.location, item?.unit?.subLocation)}
                                  styles={customStyles}
                                  onChange={(selected) => {
                                    handleChange(selected, index, 'subLocation', 'unit');
                                  }}
                                  getOptionLabel={(option) => option.label}
                                  getOptionValue={(option) => option._id}
                                />
                                <div>{get(state.error, `${index}.unitSubLocation`)}</div>
                              </FormGroup>
                            )}
                            {item?.unit?.type === 'manual' && (
                              <FormGroup className="mt-2 custom-react-select">
                                <label className="field-lbl asterisk-req">{t('PLANING_BOTTOM_UP.CHANNEL.MODAL.TYPE')}</label>
                                <Select
                                  menuPlacement="bottom"
                                  isDisabled
                                  options={[]}
                                  name="supplier"
                                  value={convertSelectLabel('Number Box')}
                                  styles={customStyles}
                                  onChange={(selected) => handleChange(selected.value, index, 'location', 'unit')}
                                />
                                <div>{get(state.error, `${index}.untiLocation`)}</div>
                              </FormGroup>
                            )}

                            <FormGroup className="mt-2 custom-react-select">
                              <label className="field-lbl asterisk-req">{t('PLANING_BOTTOM_UP.CHANNEL.MODAL.COST')}</label>
                              <Select
                                menuPlacement="bottom"
                                options={unitsColumnOption}
                                name="supplier"
                                value={convertSelectLabel(item?.cost?.type)}
                                styles={customStyles}
                                onChange={(selected) => handleChange(selected.value, index, 'cost')}
                              />

                              <div>{get(state.error, `${index}.costType`)}</div>
                            </FormGroup>

                            {item?.cost?.type === 'manual' && (
                              <FormGroup className="mt-2 custom-react-select">
                                <label className="field-lbl asterisk-req">{t('PLANING_BOTTOM_UP.CHANNEL.MODAL.TYPE')}</label>
                                <Select
                                  isDisabled
                                  menuPlacement="bottom"
                                  options={[]}
                                  name="supplier"
                                  value={convertSelectLabel('Number Box')}
                                  styles={customStyles}
                                  onChange={(selected) => handleChange(selected.value, index, 'location', 'unit')}
                                />
                              </FormGroup>
                            )}

                            {item?.cost?.type === 'source' && (
                              <FormGroup className="mt-2 custom-react-select">
                                <label className="field-lbl asterisk-req">{t('PLANING_BOTTOM_UP.CHANNEL.MODAL.LOCATION')}</label>
                                <Select
                                  menuPlacement="bottom"
                                  options={locationArray}
                                  name="supplier"
                                  value={locationArray.find((val) => val._id === item?.cost?.location)}
                                  styles={customStyles}
                                  onChange={(selected) => handleChange(selected.value, index, 'location', 'cost')}
                                />
                                <div>{get(state.error, `${index}.costLocation`)}</div>
                              </FormGroup>
                            )}

                            {item?.cost?.location && (
                              <FormGroup className="mt-2 custom-react-select">
                                <label className="field-lbl asterisk-req">{t('PLANING_BOTTOM_UP.CHANNEL.MODAL.SUB_LOCATION')}</label>
                                <Select
                                  menuPlacement="bottom"
                                  options={subLocationData}
                                  name="subLocation"
                                  value={getSubLocationValue(item?.cost?.location, item?.cost?.subLocation)}
                                  styles={customStyles}
                                  onChange={(selected) => {
                                    handleChange(selected, index, 'subLocation', 'cost');
                                  }}
                                  getOptionLabel={(option) => option.label}
                                  getOptionValue={(option) => option._id}
                                />
                                <div>{get(state.error, `${index}.costSubLocation`)}</div>
                              </FormGroup>
                            )}
                          </div>
                          <div className="flex-column-space-between">{isEmpty(updateChannelInfoData) ? showAddDeleteButtons(index) : null}</div>
                        </div>
                      );
                    })}
                </Col>
              </Row>
              <div className="modal-buttons mt-0 d-flex justify-content-between">
                <button
                  className="btn btn-default"
                  onClick={() => {
                    dispatch(action.editChannelInfo(null));
                    dispatch(action.controlChannelModal(false));
                  }}
                >
                  {t('PLANING_BOTTOM_UP.CHANNEL.MODAL.CANCEL_BUTTON')}
                </button>
                {updateChannelInfoData ? (
                  <button className="btn btn-default ml-2" onClick={() => editChannelList()}>
                    {t('PLANING_BOTTOM_UP.CHANNEL.MODAL.UPDATE_BUTTON')}
                  </button>
                ) : (
                  <button className="btn btn-default ml-2" onClick={() => addChannel()}>
                    {t('PLANING_BOTTOM_UP.CHANNEL.MODAL.ADD_BUTTON')}
                  </button>
                )}
              </div>
            </>
          ) : (
            <Loader />
          )}
        </Modal.Body>
      </Modal>

      {showChangeModal && (
        <ConfirmationPopup
          onOpen={showChangeModal}
          onConfirm={changeType}
          loading={false}
          showCheckBox
          title={t('CONFIRMATION_POPUP_VIEW.BOTTOM_UP.CHANGE_TYPE_TITLE')}
          message={t('CONFIRMATION_POPUP_VIEW.BOTTOM_UP.CHANGE_TYPE_MESSAGE')}
          secondMessage={t('CONFIRMATION_POPUP_VIEW.BOTTOM_UP.CONFIRM_TYPE_MESSAGE')}
          toggle={() =>
            setState((prestate) => ({
              ...prestate,
              showChangeModal: false,
            }))
          }
        />
      )}
    </>
  );
}

export default ChannelInfoModal;
